import { gql } from "@apollo/client";

export const UPLOAD_CONTRACT_REQUIRED_DOCUMENT = gql`
  mutation uploadContractRequiredDocument(
    $quoteId: Int!
    $contractId: Int!
    $contractSiteId: Int!
    $clientId: Int!
    $guarantorId: Int
    $dmsContentType: String!
    $uploadedFiles: [Upload!]!
  ) {
    uploadContractRequiredDocument(
      quoteId: $quoteId
      contractId: $contractId
      contractSiteId: $contractSiteId
      clientId: $clientId
      guarantorId: $guarantorId
      dmsContentType: $dmsContentType
      uploadedFiles: $uploadedFiles
    ) {
      sharePointUID
      fileName
    }
  }
`;

export const FINALIZE_QUOTE = gql`
  mutation finalizeQuote($quoteId: Int!) {
    finalizeQuote(quoteId: $quoteId) {
      quoteId
      quoteStatusId
      quoteStatusName
    }
  }
`;

export const SEND_CONTRACTUAL_DOCUMENTS_EMAIL_LINK = gql`
  mutation sendContractualDocumentsEmailLink($quoteId: Int!, $email: String) {
    sendContractualDocumentsEmailLink(quoteId: $quoteId, email: $email)
  }
`;
